<template lang="pug">
f7-button(fill, :disabled='disabled', @click='$emit("click", $event)')
  .button-box
    svg-icon(icon='filter')
    span.ellipsis {{ title }}
</template>

<style lang="scss" scoped>
#framework7-root .button {
  .svg-icon {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
}
.button-box {
  text-align: left;
}
.ellipsis {
  font-family: sans-serif;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 220px;
}
@media only screen and (min-width: 600px) {
  .ellipsis {
    width: 850px;
  }
}
</style>

<script>
export default {
  props: {
    title: { type: String, required: true },
    disabled: { type: Boolean, required: false },
  },
}
</script>
